/** @jsxImportSource @emotion/react */
import React from 'react'

import { css } from '@emotion/react'

import type { SliderItemProps } from './types'

function SliderItem({ children, className, gap = '0.5rem', itemWidth = 100, style }: SliderItemProps) {
  return (
    <li
      style={style}
      css={css`
        box-sizing: border-box;
        display: flex;
        min-width: ${itemWidth}%;
      `}
    >
      <div
        className={className}
        css={css`
          box-sizing: border-box;
          margin-left: ${gap};
          margin-right: ${gap};
          min-width: calc(${itemWidth}% - ${gap});
          width: 100%;
        `}
      >
        {children}
      </div>
    </li>
  )
}

export default SliderItem
